import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './AuthContext';
import { ThemeProvider } from './ThemeContext';
import Login from './Login';
import Signup from './Signup';
import UserDashboard from './UserDashboard';
import AdminDashboard from './AdminDashboard';
import VideoPlayerPage from './VideoPlayerPage'; // New page for video playback
import 'bootstrap/dist/css/bootstrap.min.css';
import './dark-theme.css';

function PrivateRoute({ children, role }) {
  const { user } = React.useContext(AuthContext);
  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/dashboard/user" element={<PrivateRoute role="user"><UserDashboard /></PrivateRoute>} />
              <Route path="/dashboard/admin" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
              <Route path="/video/:videoId" element={<PrivateRoute role="user"><VideoPlayerPage /></PrivateRoute>} />
              <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

function DashboardRedirect() {
  const { user } = React.useContext(AuthContext);
  if (user.role === 'admin') return <Navigate to="/admin" />;
  return <UserDashboard />;
}

export default App;
